import { supabase } from "@/integrations/supabase/client";
import type { Tables } from "@/integrations/supabase/types";

export const sportService = {
  async listActive(): Promise<Array<Pick<Tables<"sports">, "id" | "name" | "icon">>> {
    const { data, error } = await supabase
      .from("sports")
      .select("id, name, icon")
      .eq("active", true)
      .order("name");

    if (error) throw error;
    return data as Array<Pick<Tables<"sports">, "id" | "name" | "icon">>;
  },
};
